<form [formGroup]="supportForm">
	<p-fieldset legend="Your Message">
		<p-message severity="warn" styleClass="mb-3 w-full" closable="true">
			<span class="text-sm">Please provide a brief description of the issue or request.</span>
		</p-message>
		<textarea
			formControlName="message"
			fluid
			pTextarea
			style="resize: none"
			autocomplete="off"
			rows="8"
			placeholder="Describe your issue or request..."
			[tooltipPosition]="'bottom'"
			[tooltipStyleClass]="'p-tooltip-error'"
			[pTooltip]="(supportForm | isFieldInvalid: 'message') ? 'Message is required' : ''"
			[ngClass]="(supportForm | isFieldInvalid: 'message') ? ['ng-invalid', 'ng-dirty'] : []"
		></textarea>
	</p-fieldset>
</form>

<div class="mt-4 flex justify-end gap-2">
	@if (showCancelButton()) {
		<p-button label="Cancel" icon="pi pi-times" severity="secondary" [disabled]="isLoading()" (click)="onCancel()" />
	}
	<p-button
		label="Send Request"
		icon="pi pi-send"
		severity="primary"
		[disabled]="supportForm.invalid"
		[loading]="isLoading()"
		(click)="submitRequest()"
	/>
</div>
